import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../general/Icon';
const CustomCloseButton = /*#__PURE__*/memo(_ref => {
  let {
    properties,
    closeToast
  } = _ref;
  const handleCloseToast = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    closeToast();
  }, [closeToast]);
  if (!properties.closeButton && !properties.useDefaultCloseButton) return null;
  let classes = ['HoiPoi__ToastCloseButton'];
  if (properties.closeButtonClassName) classes.push(properties.closeButtonClassName);
  return /*#__PURE__*/React.createElement(React.Fragment, null, properties.useDefaultCloseButton && /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: "large",
    onClick: handleCloseToast
  }), !properties.useDefaultCloseButton && /*#__PURE__*/React.createElement("div", {
    className: classes.join(' '),
    onClick: handleCloseToast
  }, properties.closeButton));
});
process.env.NODE_ENV !== "production" ? CustomCloseButton.propTypes = {
  customCloseButton: PropTypes.element,
  closeToast: PropTypes.func
} : void 0;
export default CustomCloseButton;